<div [ngStyle]="{ color: color }">
  @if (entityAccessor.type === 'date' || entityAccessor.type === 'datetime') {
    <div>
      <date-time-component-inner
        [date]="currentValue"
        [includeTime]="entityAccessor.type === 'datetime'"
        [timezone]="entityAccessor.timezone"
      ></date-time-component-inner>
    </div>
  }
  @if (entityAccessor.type === 'time') {
    <div>
      <time-component-inner [timezone]="entityAccessor.timezone" [date]="currentValue"></time-component-inner>
    </div>
  }
  @if (entityAccessor.type === 'currency' && currency) {
    <div>
      <base-currency-component
        [currency]="currency.currency"
        [value]="currentValue"
        [locale]="currency.locale"
        [precision]="currency.currencyPrecision"
      ></base-currency-component>
    </div>
  }
  @if (entityAccessor.type === 'action' && !hidden) {
    <div>
      <default-button [color]="actionColor" (click)="handleActionClick($event, entityAccessor.action, entity)" [disabled]="disabled">
        {{ actionTitle }}
      </default-button>
    </div>
  }
  @if (!entityAccessor.type) {
    <div [innerHTML]="currentValue"></div>
  }
  <div>
    <ng-template ngxAdHost></ng-template>
  </div>
</div>
